var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0576 1H7.99995C6.62014 1 5.4579 1.93153 5.1078 3.2H3.8C2.2536 3.2 1 4.4536 1 6V12.3C1 13.8464 2.2536 15.1 3.8 15.1H8.5C9.97914 15.1 11.1904 13.953 11.293 12.5H12C13.6568 12.5 15 11.1569 15 9.5V4.13661C15 3.88784 14.9072 3.64801 14.7399 3.46393L12.7975 1.32733C12.608 1.11885 12.3393 1 12.0576 1ZM9.6834 12.5H7.99995C6.3431 12.5 4.99995 11.1569 4.99995 9.5V4.8H3.8C3.13726 4.8 2.6 5.33726 2.6 6V12.3C2.6 12.9627 3.13726 13.5 3.8 13.5H8.5C9.09459 13.5 9.58818 13.0675 9.6834 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDone);
export default __webpack_public_path__ + "static/media/copyDone.7cac44562488ed157351f31f6fb59040.svg";
export { ForwardRef as ReactComponent };